import React, { Component } from 'react';
import {
  WatchlistBaseModel,
  WatchlistEntityRequest,
  WatchlistGeneralRequest,
  WatchlistIndividualRecord,
  WatchlistIndividualRequest,
  WatchlistNameModel,
  WatchlistNameType,
} from '../../../domain/watchlist/WatchlistDomains';
import CustomTable from '../../custom/CustomTable';
import { ColumnProps } from 'primereact/column';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { WatchlistType } from '../../../constant/Constants';
import { RootState, store } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { changeWatchlist, clearWatchlist } from '../../../redux/actions/WatchlistActions';
import { initialPagePath } from '../../../redux/reducers/PageReducer';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import MessageUtil from '../../../util/MessageUtil';
import CustomPaginator, { CustomPaginatorProps } from '../../custom/CustomPaginator';
import NavigationUtil from '../../../util/NavigationUtil';
import CustomTableContentWrapper from '../../custom/CustomTableContentWrapper';
import moment from 'moment';
import CustomLoading from '../../custom/CustomLoading';
import _ from 'lodash';
import ValueUtil from '../../../util/ValueUtil';
import LanguageUtil from '../../../util/LanguageUtil';
import SafeListPubSub, { SafeListPubSubMessage } from '../../../util/SafeListPubSub';
import WatchlistUtil from '../../../util/WatchlistUtil';
import Icon from '../../../icons/Icon';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';
import { generateUUIDV4 } from '../../../util/Generator';
import { WatchlistHistoryView } from '../../../domain/watchlist/WatchlistHistoryDomains';
import JobService from '../../../service/JobService';
import { MatchManyLogResultExportJob } from '../../../domain/job/JobDomain';

class WatchlistListComponent extends Component<Props, State> {
  public state = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);
  private readonly addSafeListTooltipTargetClass = `safe-list-add_${generateUUIDV4()}`;
  private unsubscribeSafeListPubSub: (() => void) | undefined;
  private revalidateTimeoutId: ReturnType<typeof setTimeout> | undefined;
  private static readonly REVALIDATE_DELAY_MS = 800;

  public render() {
    const { history } = this.props;
    const { searchResponse, requestLoading, rows, currentPage, selectedRows, safeListLoading } = this.state;
    const startIndex = (currentPage - 1) * rows;
    const endIndex = startIndex + rows;
    const currentData = searchResponse.slice(startIndex, endIndex);

    if (requestLoading) {
      return <CustomLoading />;
    }
    return (
      <div className='w-full h-full flex flex-col relative min-h-0'>
        <div className={'relative h-0 w-full z-10 shrink-0'}>
          {history != undefined && searchResponse.length > 0 && (
            <div className={'absolute right-0 bottom-2 flex items-center'}>
              <a
                className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  this.exportHistory(history);
                }}
              >
                <Icon icon={'export'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.export', defaultMessage: 'Export' })}
                </div>
              </a>
            </div>
          )}
          {selectedRows.length > 0 && (
            <div className={'absolute right-0 bottom-2 flex items-center'}>
              <Tooltip position='left' target={`.${this.addSafeListTooltipTargetClass}`}>
                {LanguageUtil.get({ id: 'pages.watchlist.addToSafeList', defaultMessage: 'Add to Safe List' })}
              </Tooltip>
              <a
                className={`cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7] ${this.addSafeListTooltipTargetClass}`}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if (safeListLoading) {
                    return;
                  }
                  this.onAddToSafeList();
                }}
              >
                {safeListLoading ? (
                  <ProgressSpinner style={{ height: '60%', width: '60%' }} />
                ) : (
                  <Icon
                    icon={'add-to-list'}
                    size={18}
                    color={'#4F4F4F'}
                    className={'group-hover:text-primary hover:cursor-pointer flex items-center justify-center'}
                  />
                )}
              </a>
            </div>
          )}
        </div>
        <div className={'overflow-y-auto flex-1 min-h-0'}>
          <CustomTable
            loading={requestLoading}
            selectionMode={history ? undefined : 'checkbox'}
            selection={selectedRows}
            onSelectionChange={this.onSelectionChange}
            onRowClick={(e) => this.onRowClickDetail(e.data)}
            columns={this.getColumns()}
            value={currentData}
          />
        </div>
        <div className={'paginator shrink-0 bg-white'}>
          <CustomPaginator
            rows={rows}
            totalRecords={searchResponse.length}
            rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
            currentPage={currentPage}
            onPageChange={this.onPageChange}
            fixed={true}
            borderHidden={true}
          />
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const { router } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, router.location.pathname, store.getState().page);
    }
    if (this.props.history == undefined) {
      this.unsubscribeSafeListPubSub = SafeListPubSub.subscribe((message) => {
        const currentReferenceId = this.getReferenceId();
        if (currentReferenceId == undefined || currentReferenceId == null) return;
        if (message.referenceId !== currentReferenceId) return;
        this.applySafeListPubSubMessage(message);
      });
    }
    await this.getData(true);
  }

  public componentWillUnmount() {
    if (this.unsubscribeSafeListPubSub) {
      this.unsubscribeSafeListPubSub();
      this.unsubscribeSafeListPubSub = undefined;
    }
    if (this.revalidateTimeoutId != undefined) {
      clearTimeout(this.revalidateTimeoutId);
      this.revalidateTimeoutId = undefined;
    }
  }

  private applySafeListPubSubMessage = (message: SafeListPubSubMessage) => {
    const recordIds = new Set(message.records.map((record) => record.record.id));
    switch (message.action) {
      case 'add':
        this.setState((prevState) => ({
          searchResponse: prevState.searchResponse.filter((row) => !recordIds.has(row.record.id)),
          selectedRows: prevState.selectedRows.filter((row) => !recordIds.has(row.record.id)),
        }));
        break;
      case 'remove':
        this.setState((prevState) => {
          const existingIds = new Set(prevState.searchResponse.map((row) => row.record.id));
          const recordsToRestore = message.records
            .filter((record) => !existingIds.has(record.record.id))
            .map((record) => ({ ...record, isSafeListed: false }));
          const searchResponse = [...prevState.searchResponse, ...recordsToRestore].sort(
            (a: WatchlistBaseModel, b: WatchlistBaseModel) => b.score - a.score,
          );
          return { searchResponse };
        });
        break;
      default:
        break;
    }
    this.scheduleRevalidate();
  };

  private scheduleRevalidate = () => {
    if (this.revalidateTimeoutId != undefined) {
      clearTimeout(this.revalidateTimeoutId);
    }
    this.revalidateTimeoutId = setTimeout(() => {
      this.revalidateTimeoutId = undefined;
      void this.getData(false);
    }, WatchlistListComponent.REVALIDATE_DELAY_MS);
  };

  private getData = async (showLoader: boolean = true) => {
    const { router, history } = this.props;
    if (history != undefined) {
      const sortedMatches = [...history.matches].sort((a: WatchlistBaseModel, b: WatchlistBaseModel) => b.score - a.score);
      this.setState({ searchResponse: sortedMatches, selectedRows: [], requestLoading: false, type: history.type });
      return;
    }
    const previousSearchParams = new URLSearchParams(router.params.id);
    const type: string | null = previousSearchParams.get('type');
    if (showLoader) {
      this.setState({ requestLoading: true, type: type as WatchlistType });
    } else {
      this.setState({ type: type as WatchlistType });
    }
    const requestModel: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined = this.getRequestModel();
    if (requestModel == undefined) return;
    try {
      const response: WatchlistBaseModel[] = (await this.watchlistService.searchMany(requestModel, type as WatchlistType)) || [];
      const filteredResponse = response
        .filter((item: WatchlistBaseModel) => item.isSafeListed !== true)
        .sort((a: WatchlistBaseModel, b: WatchlistBaseModel) => b.score - a.score);
      this.setState({
        searchResponse: filteredResponse,
        selectedRows: [],
        requestLoading: false,
      });
    } catch (e) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.requestError', defaultMessage: 'Request Error' }),
      });
      console.error(e);
      this.setState({ requestLoading: false });
    }
  };

  private getRequestModel = (): WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined => {
    const { router, history } = this.props;
    if (history != undefined) {
      return history.request;
    }
    return WatchlistUtil.buildRequestFromSearchParams(new URLSearchParams(router.params.id));
  };

  private onRowClickDetail = (data: WatchlistBaseModel) => {
    const { type } = this.state;
    const { changeWatchlist, clearWatchlist, history } = this.props;
    clearWatchlist();
    const request = this.getRequestModel();
    const urlParams = new URLSearchParams();
    if (history != undefined) {
      urlParams.set('logId', history.logId);
    }
    urlParams.set('type', ValueUtil.convertToStringFirstChar(data.record.recordType) || '');
    urlParams.set('recordId', data.record.id || '');
    urlParams.set('name', request?.name || '');
    urlParams.set('score', data.score?.toString() || '');
    urlParams.set('level', data.level?.toString() || '');
    urlParams.set('threshold', request?.threshold.toString() || '');
    urlParams.set('lists', request?.lists.toString() || '');
    urlParams.set('email', request?.email || '');
    urlParams.set('phone', request?.phone || '');
    if (type == 'Individual') {
      urlParams.set('dateOfBirth', (request as WatchlistIndividualRequest).dateOfBirth || '');
      urlParams.set('citizenship', (request as WatchlistIndividualRequest).citizenship || '');
      urlParams.set('identification', (request as WatchlistIndividualRequest).identification || '');
      urlParams.set('referenceId', (request as WatchlistIndividualRequest).referenceId || '');
    } else if (type == 'Entity') {
      urlParams.set('dateOfRegistration', (request as WatchlistEntityRequest).dateOfRegistration || '');
      urlParams.set('identifier', (request as WatchlistEntityRequest).identifier || '');
      urlParams.set('referenceId', (request as WatchlistEntityRequest).referenceId || '');
    } else if (type == 'General') {
      urlParams.set('date', (request as WatchlistGeneralRequest).date || '');
      urlParams.set('id', (request as WatchlistGeneralRequest).id || '');
      urlParams.set('referenceId', (request as WatchlistGeneralRequest).referenceId || '');
    }
    window.open(`/${NavigationUtil.getTenant()}/watchlist/detail/${urlParams.toString()}`, '_blank', 'noopener noreferrer');
    changeWatchlist(data);
  };

  private exportHistory = async (history: WatchlistHistoryView) => {
    const job: MatchManyLogResultExportJob = {
      type: 'MATCH_MANY_LOG_RESULT_EXPORT',
      timestamp: moment().valueOf(),
      status: 'PENDING',
      logId: history.logId,
      extension: 'csv',
      path: '',
    };
    await this.jobService.schedule(job);
    MessageUtil.success({
      summary: 'Export',
      detail: <div>{LanguageUtil.get({ id: 'pages.alert.exportJobScheduled', defaultMessage: 'Export job scheduled.' })}</div>,
    });
  };

  private onSelectionChange = (e: { value: WatchlistBaseModel[] }) => {
    const { searchResponse, rows, currentPage, selectedRows } = this.state;
    const startIndex = (currentPage - 1) * rows;
    const endIndex = startIndex + rows;
    const currentPageRecordIds = new Set(searchResponse.slice(startIndex, endIndex).map((row) => row.record.id));
    const selectedOutsideCurrentPage = selectedRows.filter((row) => !currentPageRecordIds.has(row.record.id));
    this.setState({ selectedRows: [...selectedOutsideCurrentPage, ...e.value] });
  };

  private onAddToSafeList = async () => {
    const { selectedRows, type } = this.state;
    const referenceId = this.getReferenceId();

    if (referenceId == undefined || referenceId.trim().length == 0) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListReferenceIdRequired',
          defaultMessage: 'Reference ID is required to add records to Safe List!',
        }),
      });
      return;
    }

    const consolidatedRecordIds = selectedRows.map((row) => row.record.id).filter((id) => id != undefined && id.trim().length > 0);
    if (consolidatedRecordIds.length == 0) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListRecordRequired',
          defaultMessage: 'Please select at least one record!',
        }),
      });
      return;
    }

    const requestModel = this.getRequestModel();
    this.setState({ safeListLoading: true });
    try {
      await this.watchlistService.addSafeList({
        referenceId: referenceId,
        consolidatedRecordIds: consolidatedRecordIds,
        individualMatchRequest: type === 'Individual' ? (requestModel as WatchlistIndividualRequest) : null,
        entityMatchRequest: type === 'Entity' ? (requestModel as WatchlistEntityRequest) : null,
        generalMatchRequest: type === 'General' ? (requestModel as WatchlistGeneralRequest) : null,
      });
      const addedRecords = selectedRows.map((row) => ({ ...row, isSafeListed: true }));
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListAddSuccess',
          defaultMessage: 'Selected records added to Safe List!',
        }),
      });
      this.setState({ safeListLoading: false });
      SafeListPubSub.publish({ referenceId: referenceId, action: 'add', records: addedRecords });
    } catch (e) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListAddError',
          defaultMessage: 'Failed to add records to Safe List!',
        }),
      });
      console.error(e);
      this.setState({ safeListLoading: false });
    }
  };

  private getReferenceId = (): string | null => {
    const requestModel = this.getRequestModel();
    if (requestModel == undefined || requestModel.referenceId == undefined) {
      return null;
    }
    return requestModel.referenceId;
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    this.setState({ rows: event.rows, currentPage: event.page });
  };

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'score',
        header: LanguageUtil.get({ id: 'pages.watchlist.table.score', defaultMessage: 'Score' }),
        className: 'min-w-[200px] max-w-[200px]',
        headerClassName: 'h-[44px] 2xl:h-[52px]',
        body: (record: WatchlistBaseModel) => {
          return (
            <div className={`flex flex-col justify-center items-center ${this.getScoreItem(record.score)} min-w-[52px] w-[52px] rounded-[50px] h-[25px]`}>
              {record.score}
            </div>
          );
        },
      },
      {
        field: 'name',
        header: LanguageUtil.get({ id: 'pages.watchlist.table.name', defaultMessage: 'Name' }),
        className: 'w-1/3',
        sortable: false,
        body: (record: WatchlistBaseModel) => {
          return (
            <div className={'flex items-center text-f-black-3 text-xs 2xl:text-md'}>
              <div className={'w-8 h-8 flex items-center justify-center rounded-full bg-[#F4F3FF] mr-1'}>{this.getImage(record)}</div>
              {this.getName(record)}
            </div>
          );
        },
      },
      {
        field: 'category',
        header: LanguageUtil.get({ id: 'pages.watchlist.table.category', defaultMessage: 'Category' }),
        className: 'w-1/3',
        sortable: false,
        body: (record: WatchlistBaseModel) => {
          return (
            <div className={'flex items-center gap-x-2'}>
              {this.getCategory(record)?.map((value: string, index: number) => {
                return (
                  <span
                    key={index}
                    className={`flex text-xs shrink-0 2xl:text-md h-full justify-center px-[16px] py-[3px] items-center rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {value}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      {
        field: 'level',
        header: 'Level',
        className: 'w-1/3',
        sortable: false,
        body: (record: WatchlistBaseModel) => {
          return (
            <div className={'flex items-center text-f-black-3 text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={record?.level ? this.getLevel(record.level, record?.record?.recordType) : 'N/A'} />
            </div>
          );
        },
      },
      {
        field: 'record.createdAt',
        header: LanguageUtil.get({ id: 'pages.watchlist.table.createdAt', defaultMessage: 'Created Date' }),
        alignHeader: 'left',
        columnKey: 'createdAt',
        className: 'w-1/3',
        sortable: true,
        body: (record: WatchlistBaseModel) => {
          return (
            <div className={'flex items-start text-f-black-3 text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={moment(record.record.createdAt).format('LLL')} />
            </div>
          );
        },
      },
    ];
  };

  private getLevel = (level: number, type: string) => {
    if (type == 'INDIVIDUAL') {
      switch (level) {
        case 1:
          return 'Identification';
        case 2:
          return 'Name';
        case 3:
          return 'Name, Date of Birth';
        case 4:
          return 'Name, Citizenship';
        case 5:
          return 'Name, Date of Birth, Citizenship';
        default:
          return 'N/A';
      }
    } else if (type == 'ENTITY') {
      switch (level) {
        case 1:
          return 'Identifier';
        case 2:
          return 'Name';
        case 3:
          return 'Name, Date of Registration';
        default:
          return 'N/A';
      }
    } else {
      return 'N/A';
    }
  };

  private getCategory = (response: WatchlistBaseModel) => {
    if (response == undefined) return;
    const categories: string[][] = [];
    response.record.records.forEach((recordItem) => {
      categories.push(recordItem.watchlistRecord.categories);
    });
    return _.uniqBy([].concat(...categories) as string[], (value) => value);
  };

  private getScoreItem = (score: number) => {
    if (score <= 25) {
      return 'bg-[#DBF8E5] text-[#3F9E2C]';
    } else if (score > 25 && score <= 50) {
      return 'bg-[#FCF1BB] text-[#C57500]';
    } else if (score > 50) {
      return 'bg-[#FFF1F3] text-[#D2332F]';
    }
  };

  private getName = (response: WatchlistBaseModel): string => {
    if (response === undefined) return 'Name Undefined';
    const flattenedArray: WatchlistNameModel[][] =
      response.record.records?.map((value) => {
        return value.watchlistRecord.names;
      }) || [];
    const namesData: WatchlistNameModel[] = ([] as WatchlistNameModel[]).concat(...flattenedArray);
    if (namesData.length === 0)
      return LanguageUtil.get({ id: 'pages.watchlist.pdfReportComponent.nameUndefined', defaultMessage: 'Name Undefined' });
    const longestPrimaryData: WatchlistNameModel[] = namesData.filter((item: WatchlistNameModel) => item.nameType === WatchlistNameType.PRIMARY);
    if (longestPrimaryData.length === 0) return namesData[0].value;
    const data: WatchlistNameModel = longestPrimaryData.reduce((a, b) => (a.value.length > b.value.length ? a : b));
    return data.value;
  };

  private getImage = (record: WatchlistBaseModel) => {
    if (record != undefined) {
      if (record.record.recordType == 'INDIVIDUAL') {
        const images = record.record?.records?.filter(
          (recordItem) =>
            (recordItem.watchlistRecord as WatchlistIndividualRecord).images &&
            (recordItem.watchlistRecord as WatchlistIndividualRecord).images.length > 0,
        );
        if (images != undefined && images.length > 0) {
          return (
            <img
              src={(images[0].watchlistRecord as WatchlistIndividualRecord).images[0]}
              alt='-'
              className={'w-8 h-8 flex justify-center items-center rounded-[50%] bg-[#EFF2FE] object-cover'}
            />
          );
        }
        return <img src={'/icons/individual.svg'} alt='individual' />;
      } else {
        return <img src={'/icons/entity.svg'} alt='entity' />;
      }
    }
  };
}

interface Props extends FormicaProps, ReduxProps {
  history?: WatchlistHistoryView;
}

const mapStateToProps = (state: RootState) => ({
  watchlist: state.watchlist,
});
const mapDispatchToProps = { changeWatchlist, clearWatchlist };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  searchResponse: WatchlistBaseModel[] = [];
  selectedRows: WatchlistBaseModel[] = [];
  requestLoading: boolean = false;
  safeListLoading: boolean = false;
  type: WatchlistType = 'Individual';
  rows: number = 10;
  currentPage: number = 1;
}

export default withFormica(connector(WatchlistListComponent));
